export type CategoryResponses = "fas" | "fab" | "far";

export const CategoryTypes: CategoryResponses[] = ["fab", "fas", "far"];
